import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EventoDetalhesPage } from '../../evento/evento-detalhes/evento-detalhes.page';
import { EventoProvider } from 'src/app/services/evento/evento';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';

@Component({
  selector: 'app-pessoa-projetos-ensinos',
  templateUrl: './pessoa-projetos-ensinos.page.html',
  styleUrls: ['./pessoa-projetos-ensinos.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SemRegistroComponent,
    NomenclaturaPipe
  ],
})
export class PessoaProjetosEnsinosPage implements OnInit {
  eventoTipo: string = 'projeto';
  eventos: any = { ensinos: [], projetos: [] };
  evento: any = {};
  idPessoa: string = '';
  loaded: boolean = false;
  isEnsino: any;
  id: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public eventoProvider: EventoProvider,
    public loadingController: LoadingController,
    private translate: TranslateService,
    public modalCtrl: ModalController
  ) {
    this.idPessoa = this.navParams.get('idPessoa');

    this.eventoProvider.projetosPessoa(this.idPessoa).subscribe((data) => {
      this.eventos = data;
      this.loaded = true;
    });
  }

  ngOnInit() {}

  public async eventoDetalhes(projeto: { id: any; }) {
    this.isEnsino = '1';
    this.id = projeto.id;
    const modalPage = await this.modalCtrl.create({ component: EventoDetalhesPage, componentProps: { id: this.id, isEnsino: this.isEnsino } });
    modalPage.present();
  }

  public async ensinoDetalhes(ensino: { id: any; }) {
    this.isEnsino = '2';
    this.id = ensino.id;
    const modalPage = await this.modalCtrl.create({ component: EventoDetalhesPage, componentProps: { id: this.id, isEnsino: this.isEnsino } });
    modalPage.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

}
